import { useEffect, useState } from 'react';
import { DatePicker, message } from 'antd';
import dayjs from 'dayjs';
import { buildSchedule, errorText } from './helpers';

const hours = Array.from({ length: 24 }, (_, index) => index);
const minutes = Array.from({ length: 60 }, (_, index) => index);

export function schedulePickerLimits(zone, now = dayjs()) {
    const cutoff = dayjs(now).add(5, 'minute').tz(zone);
    const cutoffDay = cutoff.format('YYYY-MM-DD');
    // The form stores wall-clock minutes; choose the first whole minute after the cutoff.
    const firstValue = dayjs(cutoff.add(1, 'minute').startOf('minute').format('YYYY-MM-DDTHH:mm'));
    return {
        defaultPickerValue: firstValue,
        showNow: false,
        showTime: { format: 'HH:mm', defaultOpenValue: firstValue },
        disabledDate: (date) => date.format('YYYY-MM-DD') < cutoffDay,
        disabledTime: (date) => {
            const dateDay = date?.format('YYYY-MM-DD') || cutoffDay;
            if (dateDay > cutoffDay) return {};
            if (dateDay < cutoffDay) return { disabledHours: () => hours, disabledMinutes: () => minutes };
            return {
                disabledHours: () => hours.filter((hour) => hour < cutoff.hour()),
                disabledMinutes: (hour) => hour < cutoff.hour() ? minutes
                    : hour === cutoff.hour() ? minutes.filter((minute) => minute <= cutoff.minute()) : [],
            };
        },
    };
}

export default function SchedulePicker({ value, onChange, zone }) {
    const [open, setOpen] = useState(false);
    const [now, setNow] = useState(dayjs);
    useEffect(() => {
        if (!open) return;
        const timer = setInterval(() => setNow(dayjs()), 1000);
        return () => clearInterval(timer);
    }, [open]);
    return <DatePicker aria-label="预约日期与时间" value={value} format="YYYY-MM-DD HH:mm" style={{ width: '100%' }}
        {...schedulePickerLimits(zone, now)} onOpenChange={(next) => { setNow(dayjs()); setOpen(next); }}
        onChange={(next) => {
            if (next) {
                try { buildSchedule('scheduled', next, zone); }
                catch (error) { message.error(errorText(error)); return; }
            }
            onChange(next);
        }} />;
}
